import { render, staticRenderFns } from "./DischargeNotes.vue?vue&type=template&id=6330120e&"
import script from "./DischargeNotes.vue?vue&type=script&lang=ts&"
export * from "./DischargeNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6330120e')) {
      api.createRecord('6330120e', component.options)
    } else {
      api.reload('6330120e', component.options)
    }
    module.hot.accept("./DischargeNotes.vue?vue&type=template&id=6330120e&", function () {
      api.rerender('6330120e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/discharge/DischargeNotes.vue"
export default component.exports